import { render, staticRenderFns } from "./PreviewFile.vue?vue&type=template&id=a0f56294&scoped=true&"
import script from "./PreviewFile.vue?vue&type=script&lang=ts&"
export * from "./PreviewFile.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewFile.vue?vue&type=style&index=0&id=a0f56294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f56294",
  null
  
)

export default component.exports